var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user",
    transform: "translate(1699 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 37,
    height: 37,
    transform: "translate(-1699 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-1695.75 32.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M16.125,3.964A4.286,4.286,0,1,1,11.839,8.25a4.286,4.286,0,0,1,4.286-4.286m0-1.714a6,6,0,1,0,6,6A6,6,0,0,0,16.125,2.25Z",
    transform: "translate(-0.804 0)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M23.893,30.536H22.179V26.25a4.286,4.286,0,0,0-4.286-4.286H12.75A4.286,4.286,0,0,0,8.464,26.25v4.286H6.75V26.25a6,6,0,0,1,6-6h5.143a6,6,0,0,1,6,6Z",
    transform: "translate(0 -4.286)",
    fill: "#c1c1c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.70feae6a4feda9d88907c86e6995578d.svg";
export { ForwardRef as ReactComponent };